import moment from "moment";
import React from "react";
import { US_STATES } from "../../../../../../../../../consts/general";
import { useContext } from "../../../context";

const GfeClientDetails = () => {
  const { appointment } = useContext();

  const userDateFormat = localStorage.getItem("dateFormat") || "MM/DD/YYYY";

  const formatUserDate = (date) => {
    return moment.utc(date).format(userDateFormat);
  };

  const stateName = () =>
    US_STATES.find((state) => state.abbr === appointment?.patient?.state)?.name;

  return (
    <>
      <div className="detail-row">
        <label htmlFor="dob">Date of Birth:</label>
        <span>{formatUserDate(appointment?.patient?.dateOfBirth) || ""}</span>
      </div>
      <div className="detail-row">
        <label htmlFor="state">State:</label>
        <span>{stateName() || ""}</span>
      </div>
    </>
  );
};

export default GfeClientDetails;
